import type { components } from '@/api/schema'

type NamedResource = Pick<
  components['schemas']['ClassificationResourceRead'],
  'id' | 'name' | 'parent_id'
>

export function resourceName(
  resource: NamedResource,
  resources: NamedResource[],
) {
  const names = [resource.name]
  const visited = new Set([resource.id])
  let parent = resources.find((item) => item.id === resource.parent_id)
  while (parent && !visited.has(parent.id)) {
    names.unshift(parent.name)
    visited.add(parent.id)
    parent = resources.find((item) => item.id === parent?.parent_id)
  }
  return names.join(' / ')
}
